/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
    createEntityListActions,
    createEntityListState,
    createEntityMapActions,
    createEntityMapState,
    createGenericStore,
    createSingleSelectActions,
    createSingleSelectState
} from "@microsoft/shifts-experiences-shared";

import { CrossLocationTeamsActions } from "./CrossLocationTeamsActions";
import { CrossLocationTeamsState } from "./CrossLocationTeamsState";

/**
 * The cross location teams store and actions.
 */
const { actions, store } = createGenericStore<CrossLocationTeamsState, CrossLocationTeamsActions>({
    actionsCreators: [createEntityListActions, createEntityMapActions, createSingleSelectActions],
    namespace: "CrossLocationTeamsStore",
    statesCreators: [createEntityListState, createEntityMapState, createSingleSelectState]
});

/**
 * The store which holds the list of cross-location teams and the selected team id, if any.
 */
export const CrossLocationTeamsStore = store;

/**
 * The actions for the cross-location teams store.
 */
export const crossLocationTeamsActions = actions;
